/**
 * @param {CompanyBuildingCreate} address
 * @returns {ApiCompanyBuildingCreate}
 */
export const formatCreateBuilding = (address) => ({
  description: address.description,
  neighborhood: address.neighborhood,
  zipcode: address.zipcode.replace('-', ''),
  cityId: address.cityId,
  street: address.street,
  streetNumber: address.streetNumber,
  complementary: address.streetDetails,
  addressType: address.addressType || null,
  isMain: address.isMain,
})

/**
 * @param {CompanyBuildingUpdate} address
 * @returns {ApiCompanyBuildingUpdate}
 */
export const formatUpdateBuilding = (address) => ({
  id: address.id,
  description: address.description,
  neighborhood: address.neighborhood,
  zipcode: address.zipcode.replace('-', ''),
  cityId: address.cityId,
  street: address.street,
  streetNumber: address.streetNumber,
  complementary: address.streetDetails,
  addressType: address.addressType || null,
  isMain: address.isMain,
})

/**
 * @param {CompanyBuildingUpdate} address
 * @returns {ApiCompanyBuildingUpdate}
 */
export const formatAddBuilding = (address) => ({
  description: address.description,
  neighborhood: address.neighborhood,
  zipcode: address.zipcode.replace('-', ''),
  cityId: address.cityId,
  street: address.street,
  streetNumber: address.streetNumber,
  complementary: address.streetDetails,
  addressType: address.addressType || null,
  isMain: address.isMain,
})

export default {
  formatCreateBuilding,
  formatUpdateBuilding,
  formatAddBuilding,
}
